import { Dialog, DialogContent, Box, Typography, DialogActions, FormHelperText, Button, TextField, Alert } from '@mui/material';
import { setArticleFolderDetailsData } from '../../../redux/articleFolderDetailsDataSlice';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Iconify from '../../Iconify';
import { useFormik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import '../../../css/roles/updateRoleName.css';

export const UpdateArticleFolderName = ({ updateArticleFolderOpen, setUpdateArticleFolderOpen }) => {

    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [errMsg, setErrMsg] = useState(null);
    const articleFolderDetailsData = useSelector((state) => state.ArticleFolderDetailsData);

    const formik = useFormik({
        initialValues: {
            title: articleFolderDetailsData?.title || '',
        },
        validationSchema: Yup.object().shape({
            title: Yup.string().required(t('isRequired')),
        }),
        onSubmit: async (values) => {
            try {
                const response = await axios.patch(`article-folder/${articleFolderDetailsData.id}`, values);
                if (response.status === 200 || response.status === 201) {
                    dispatch(setArticleFolderDetailsData({ ...articleFolderDetailsData, title: response.data.title }));
                    dispatch(setSuccessfullModifyDialog({ open: true, type: "Modifier le titre de dossier" }));
                    setUpdateArticleFolderOpen(false);
                }
            } catch (error) {
                setErrMsg(error?.response?.data?.message || error.message || 'Erreur lors de la modification de titre de dossier');
                console.error('Error updating folder name:', error);
            }
        },
    });

    const { handleSubmit, values, handleChange, handleBlur, touched, errors } = formik;

    return (
        <Dialog open={updateArticleFolderOpen} fullWidth>
            <Box onClick={() => setUpdateArticleFolderOpen(false)} className='updateRoleName_icon_text'>
                <Typography className='updateRoleName_title'>{t("Modifier le titre de dossier")}</Typography>
                <Iconify icon={"material-symbols:close"} className='updateRoleName_close_icon' />
            </Box>
            {errMsg && <Alert key={errMsg} severity="error">{errMsg}</Alert>}
            <form onSubmit={handleSubmit}>
                <DialogContent className='updateRoleName_dialog_content'>
                    <Box className="updateRoleName_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="updateRoleNameInputTitle">{t('Titre')}</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.title}
                            className='updateRoleName_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="title"
                            error={touched.title && Boolean(errors.title)}
                            helperText={touched.title && errors.title}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                </DialogContent>
                <DialogActions className='updateRoleName_dialog_actions'>
                    <Button className='updateRoleName_button_annuler' onClick={() => setUpdateArticleFolderOpen(false)}>{t('Annuler')}</Button>
                    <Button className='updateRoleName_button_valider' variant="contained" type="submit">{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};